import { useAuthContext } from 'src/auth/hooks';
import { TRYVISA, AGENT } from 'src/_config/brandConfig';

export default function useBrandName() {
  const { user } = useAuthContext();
  const { hostname, port } = window.location;

  // Check if we're in a production environment
  const isDomainAgent = hostname === AGENT.domain || hostname === `dev.${AGENT.domain}`;
  const isDomainTryVisa =
    (hostname === TRYVISA.domain || hostname === `dev.${TRYVISA.domain}`) && !isDomainAgent;
  // For local development, check the port
  const isLocalDevelopment =
    ['localhost', '127.0.0.1', '0.0.0.0'].includes(hostname) ||
    /^192\.168\.|^10\.|^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname);
  const isAgentPort = port === AGENT.port.toString();

  // Determine brand name based on user purpose and domain/port
  const brandName = (() => {
    // if (user && user?.company_id?.purpose === COMPANY_PURPOSE_TYPES.AGENT.value) {
    //   return TRYVISA.brandName;
    // }
    // if (user && user?.company_id?.purpose === COMPANY_PURPOSE_TYPES.BUSINESS.value) {
    //   return AGENT.brandName;
    // }

    // If user info not available, check domain/port
    if (isDomainTryVisa) return TRYVISA.brandName;
    if (isDomainAgent) return AGENT.brandName;
    if (isLocalDevelopment) return isAgentPort ? AGENT.brandName : TRYVISA.brandName;

    return TRYVISA.brandName; // Default to TryVisa
  })();

  // Get the appropriate brand object
  const brand = brandName === TRYVISA.brandName ? TRYVISA : AGENT;

  return {
    brandName,
    supportPhone: brand.supportPhone,
    supportEmail: brand.supportEmail,
    demoBookUrl: brand.demoBookUrl,
    whatsappSupportLink: brand.supportWhatsapp,
    privacyPolicyUrl: brand.privacyPolicyUrl,
    termsUrl: brand.termsUrl,
    logoUrl: brand.logoUrl,
    websiteUrl: brand.websiteUrl,
    dashboardUrl: brand.dashboardUrl,
    isTryVisa: brandName === TRYVISA.brandName,
    isAgent: brandName === AGENT.brandName,
    isAgentPurpose: user?.purpose === 'AGENT',
    isLocalDevelopment,
  };
}
